import React from "react";
import { Link } from "react-router-dom";
import { fmtEUR, pct } from "../lib/api";

export default function AthleteCard({ athlete, variant = "default", index = 0 }) {
  const id = athlete.slug || athlete.athlete_id;
  const progress = pct(athlete.funding_raised, athlete.funding_goal);

  if (variant === "tall") {
    return (
      <Link
        to={`/golfers/${id}`}
        className="group block flat-card overflow-hidden relative"
        data-testid={`athlete-card-${id}`}
      >
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={athlete.image_url}
            alt={athlete.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
            <div className="text-[10px] uppercase tracking-[0.22em] opacity-80">
              {[athlete.country, athlete.tour_level].filter(Boolean).join(" · ")}
            </div>
            <div className="font-display text-3xl mt-1">{athlete.name}</div>
            <div className="mt-4 flex items-end justify-between">
              <div>
                <div className="text-xs opacity-75">Raised</div>
                <div className="font-display text-xl">{fmtEUR(athlete.funding_raised)}</div>
              </div>
              <div className="text-right">
                <div className="text-xs opacity-75">Goal</div>
                <div className="font-display text-xl">{fmtEUR(athlete.funding_goal)}</div>
              </div>
            </div>
            <div className="mt-3 h-px bg-white/30 relative">
              <div
                className="absolute left-0 top-0 h-px bg-[hsl(var(--secondary))]"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/golfers/${id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`athlete-card-${id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden border border-border">
        <img
          src={athlete.image_url}
          alt={athlete.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {athlete.featured && (
          <div className="absolute top-3 left-3 bg-background px-2 py-1 text-[10px] uppercase tracking-[0.22em]">
            Featured
          </div>
        )}
        {athlete.tgi_featured && (
          <div className="absolute top-3 right-3 bg-primary text-primary-foreground px-2 py-1 text-[10px] uppercase tracking-[0.22em]">
            In TGI
          </div>
        )}
      </div>
      <div className="pt-4">
        <div className="overline text-foreground/60">
          {[athlete.country, athlete.tour_level].filter(Boolean).join(" · ")}
        </div>
        <div className="font-display text-2xl mt-1 group-hover:text-primary transition-colors">
          {athlete.name}
        </div>
        <div className="mt-3 text-xs text-foreground/60">
          {fmtEUR(athlete.funding_raised)} <span className="opacity-50">raised of {fmtEUR(athlete.funding_goal)}</span>
        </div>
        <div className="mt-2 h-px bg-border relative">
          <div className="absolute left-0 top-0 h-px bg-primary" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </Link>
  );
}
